import React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { isNil } from 'lodash';
import { IntRange, IntRangeString } from '@payer-admin-ui/components-v2/src/functions/numbers';

export type ExtendedNumberFormatProps = {
  value: number;
  fractionDigits?: IntRangeString;
  nullable?: boolean;
} & NumericFormatProps;

const ExtendedNumberFormat = ({
  value,
  fractionDigits = '0..',
  nullable = false,
  ...props
}: ExtendedNumberFormatProps) => {
  if (nullable && isNil(value)) {
    return null;
  }

  return (
    <NumericFormat
      displayType="text"
      thousandSeparator={' '}
      style={{ whiteSpace: 'nowrap' }}
      {...props}
      value={extendedNumberFormat(value, { fractionDigits })}
      valueIsNumericString
    />
  );
};

const extendedNumberFormat = (
  value: number,
  {
    fractionDigits = '0..',
    locale = 'en-US',
  }: {
    fractionDigits?: IntRangeString;
    locale?: string;
  } = {},
) => {
  const fractionDigitsRange = IntRange.fromString(fractionDigits);

  return new Intl.NumberFormat(locale, {
    useGrouping: false,
    minimumFractionDigits: fractionDigitsRange.min ?? 0,
    maximumFractionDigits: fractionDigitsRange.max ?? 20, // 20 is the max allowed
  }).format(value || 0); // to avoid -0 which may otherwise occur
};

export { ExtendedNumberFormat, extendedNumberFormat };
